import { useState } from 'react';
import { useLang } from '../context/LangContext';

export default function ShareButtons({ title = '' }) {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);

  const url = window.location.href;
  const encodedUrl   = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const whatsappUrl  = `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`;
  const telegramUrl  = `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`;

  return (
    <div className="single-share">
      <span className="share-label">{t('sf.share')}</span>

      <button
        className="share-btn"
        onClick={handleCopy}
        style={copied ? { background: 'var(--g1)', color: '#fff' } : {}}
      >
        {copied ? '✅' : '📋'} {copied ? (t('sf.copy').replace('📋 ', '') + ' ✓') : t('sf.copy')}
      </button>

      <a
        href={whatsappUrl}
        target="_blank"
        rel="noreferrer"
        className="share-btn"
        style={{ textDecoration: 'none' }}
      >
        {t('sf.whatsapp')}
      </a>

      <a
        href={telegramUrl}
        target="_blank"
        rel="noreferrer"
        className="share-btn"
        style={{ textDecoration: 'none' }}
      >
        {t('sf.telegram')}
      </a>
    </div>
  );
}